"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

var burnerComponents_1 = __importDefault(require("./components/burnerComponents"));

var Header_1 = __importDefault(require("./components/Header"));

var Loading_1 = __importDefault(require("./components/Loading"));

var Scanner_1 = __importDefault(require("./components/Scanner"));

var BurnerProvider_1 = __importDefault(require("./BurnerProvider"));

var Pages_1 = __importDefault(require("./Pages"));

var Template_1 = __importDefault(require("./Template"));

var HistoryProvider_1 = __importDefault(require("./HistoryProvider"));

var Plugins_1 = __importDefault(require("./Plugins"));

var BurnerUI =
/** @class */
function (_super) {
  __extends(BurnerUI, _super);

  function BurnerUI(props) {
    var _this = _super.call(this, props) || this;

    _this.plugins = new Plugins_1.default(props.plugins, _this);
    _this.state = {
      pluginData: _this.plugins.getData()
    };
    return _this;
  }

  BurnerUI.prototype.componentDidMount = function () {
    var _this = this;

    this.plugins.onDataChange(function (pluginData) {
      return _this.setState({
        pluginData: pluginData
      });
    });
  };

  BurnerUI.prototype.getCore = function () {
    return this.props.core;
  };

  BurnerUI.prototype.getAssets = function () {
    return this.props.core.getAssets();
  };

  BurnerUI.prototype.render = function () {
    return react_1.default.createElement(react_router_dom_1.BrowserRouter, null, react_1.default.createElement(BurnerProvider_1.default, {
      core: this.props.core,
      pluginData: this.state.pluginData,
      burnerComponents: burnerComponents_1.default
    }, react_1.default.createElement(HistoryProvider_1.default, {
      core: this.props.core
    }, react_1.default.createElement(Template_1.default, {
      theme: this.props.theme
    }, react_1.default.createElement(Loading_1.default, null), react_1.default.createElement(Scanner_1.default, null), react_1.default.createElement(Header_1.default, {
      title: this.props.title
    }), react_1.default.createElement(Pages_1.default, {
      pluginData: this.state.pluginData
    })))));
  };

  BurnerUI.defaultProps = {
    plugins: []
  };
  return BurnerUI;
}(react_1.Component);

exports.default = BurnerUI;